import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import axios from "../../../../axios/index";

// Context
import { UserContext } from "../../../Context/UserContextProvider";

// inputs validation
import { addNoteValidate } from "../../../Dashboard/Notes/AddNote/addNoteValidate";

// styles
import styles from "../../../Dashboard/Notes/AddNote/AddNote.module.css";
import Dstyles from "../UserMyNotes/UserMyNotes.module.css";
import btnStyles from "../../../Dashboard/DashboardFileManagement/DashboardFileManagement.module.css";
import inputStyles from "../../../Dashboard/Meeting/AddMeeting/AddMeeting.module.css";
import "react-toastify/dist/ReactToastify.css";

// components
import HomeNavbar from "../../../Home/HomeNavbar/HomeNavbar";
import Footer from "../../../Home/Footer/Footer";
import UserSideDashboard from "../../UserSideDashboard/UserSideDashboard";

export default function UserAddNote() {
  const { userToken } = useContext(UserContext);
  const history = useHistory();
  const [btnLoader, setBtnLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [addNoteInfo, setAddNoteInfo] = useState({
    title: "",
    description: "",
  });

  useEffect(() => {
    setErrors(addNoteValidate(addNoteInfo));
  }, [addNoteInfo]);

  return (
    <>
      <div className="d-flex justify-content-center align-items-start vw-100 position-relative" dir="rtl">
        <div className="w-100 ms-0 p-0" style={{ background: "#FFFFFF" }}>
          <HomeNavbar />
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover={false}
            theme="light"
          />
          <div className="container py-3 px-0 mt-4">
            <div className="w-100 d-flex justify-content-md-between justify-content-center align-items-start">
              <UserSideDashboard notes />
              <div className={`d-flex flex-column align-items-center justify-content-start p-md-4 p-3 ${Dstyles.main_container}`}>
                <div className="w-100 text-end mb-md-5 mb-3">
                  <div className={`my-md-0 my-3 ${Dstyles.title}`}>یادداشت‌ها</div>
                </div>
                <div className="w-100 d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3" dir="rtl">
                  <div className="w-100 d-flex flex-column justify-content-center align-items-center">
                    <div className="d-flex align-items-start justify-content-center flex-column my-3 w-100">
                      <div className={`mb-3 ${inputStyles.input_top_title}`}>عنوان یادداشت</div>
                      <input className={`w-100 ${inputStyles.input}`} type="text" name="title" value={addNoteInfo.title} onChange={changeHandler} />
                    </div>
                    <div className="w-100 d-flex flex-column justify-content-center align-items-start my-4">
                      <div className={`mb-3 ${inputStyles.input_top_title}`}>متن یادداشت</div>
                      <textarea
                        type="text"
                        name="description"
                        value={addNoteInfo.description}
                        className={`w-100 px-3 pt-3 ${styles.textarea}`}
                        onChange={changeHandler}></textarea>
                    </div>
                  </div>
                </div>

                <div className="w-100 d-flex justify-content-end flex-wrap align-items-center my-3" dir="rtl">
                  <div className="w-100 d-flex align-items-end justify-content-center flex-column">
                    {btnLoader ? (
                      <div className={btnStyles.btn_loader_container}>
                        <div className={btnStyles.btn_spinner}></div>
                      </div>
                    ) : (
                      <button type="submit" className={`btn ${styles.submit_btn}`} onClick={submitHandler}>
                        ثبت
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );

  function changeHandler(event) {
    setAddNoteInfo(prev => {
      return { ...prev, [event.target.name]: event.target.value };
    });
  }

  function submitHandler() {
    if (!Object.keys(errors).length) {
      notify("درحال ایجاد یادداشت جدید", "success");
    } else {
      notify("!لطفا تمام فیلد هارا پرکنید", "error");
    }
  }

  function notify(text, type) {
    if (type === "success") {
      toast.success(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      postHandler();
    } else {
      toast.error(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setBtnLoader(false);
    }
  }

  async function postHandler() {
    setBtnLoader(true);
    const title = addNoteInfo.title;
    const description = addNoteInfo.description;

    var data = new FormData();
    data.append("Title", title);
    data.append("Description", description);

    const apiData = await axios.post("Note", data, {
      headers: { authorization: "Bearer " + userToken },
    });
    // console.log(apiData)
    history.push("/user-my-notes");
    setBtnLoader(false);
  }
}
